import '@src/styles/cardOrder/orderSummary.scss';
import { CustomImage, Text, useText } from '@src/components';
import OrderSummaryInformation from './OrderSummaryInformation';
import CardDetailInformation from './CardDetailInformation';
import iconBack from '@src/assets/icons/icon-back.svg';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { cardOrdersDelete, cardOrdersUpdate, prevStep } from '@src/store/slice/cardOrderSlice';
import { useCallback, useEffect, useState } from 'react';
import { handleAuthStatus, isCreditCardUser, dataLayer } from '@src/utils/utils';
import { useHistory } from 'react-router-dom';
import { confirmDialog } from '@src/components/CustomDialog';
import { getCustomerVouListForGift } from '@src/store/slice/customerSlice';
import { VouIdCode } from '@src/store/enums';

const OrderSummary = () => {
  const dispatch = useDispatch();
  const { currentCardOrder, cardOrderPopupDigital } = useSelector((state) => state?.cardOrder);
  const { customerVou, selectedCustomer } = useSelector((state) => state?.customer);
  const history = useHistory();
  const [isExitOrder, setIsExitOrder] = useState(false);
  const { userAuthorizationGiftStatus } = useSelector((state) => state?.user);

  const giveUpText = useText('giveUp');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const warningHtmlContent = <Text t="youAreLeavingThePageTheOrderInformation" />;

  useEffect(() => {
    const orderSummaryHistoryBlock = history.block((location) => {
      if (isExitOrder) {
        return true;
      }
      if (currentCardOrder?.id) {
        confirmDialog({
          title: <Text t="attention" />,
          htmlContent: warningHtmlContent,
          okText: <Text t="yes" />,
          cancelText: <Text t={giveUpText} />,
          closeIcon: false,
          onCancel: async (e) => {
            setIsExitOrder(false);
            return false;
          },
          onOk: async () => {
            setIsExitOrder(true);
            await dispatch(cardOrdersDelete());
            history.push(location.pathname);
          },
        });
      } else {
        return true;
      }

      return false;
    });

    return orderSummaryHistoryBlock;
  }, [history, isExitOrder, dispatch, currentCardOrder]);

  const clickOrderApproval = useCallback(async () => {
    const body = { ...currentCardOrder };
    const hasApproval = hasAuthorization(userAuthorizationGiftStatus, 'ApprovalAuthorizationGroup');
    const hasPayment = hasAuthorization(userAuthorizationGiftStatus, 'PaymentAuthorizationGroup');

    const totalPrice = currentCardOrder?.totalPrice || 0;

    let customerPamId = customerVou?.pamId;
    let complimentsCustomerVou = null;
    const isCompliments = currentCardOrder?.vouId === VouIdCode.Compliments;
    if (isCompliments) {
      const giftCustomerInfo = await dispatch(
        getCustomerVouListForGift({
          customerId: selectedCustomer?.customerId,
          vouId: VouIdCode.Compliments,
        }),
      );
      if (giftCustomerInfo?.payload?.data[0]?.pamId) {
        complimentsCustomerVou = giftCustomerInfo?.payload?.data[0];
        customerPamId = giftCustomerInfo?.payload?.data[0]?.pamId;
      }
    }
    const isCreditCard = isCreditCardUser(
      isCompliments && complimentsCustomerVou ? complimentsCustomerVou : customerVou,
    );
    if (!hasApproval || !hasPayment) {
      handleAuthorization(body, isCreditCard, totalPrice, customerPamId);
    } else {
      handleApprovedOrder(body, isCreditCard, customerPamId);
    }
    await dispatch(cardOrdersUpdate(body));
    logOrderSummary(body);
  }, [currentCardOrder, dispatch, customerVou]);

  function hasAuthorization(authorizationStatus, group) {
    return handleAuthStatus(authorizationStatus || [], group);
  }

  function handleAuthorization(body, isCreditCard, totalPrice, customerPamId) {
    if (isCreditCard) {
      body.orderStatus = totalPrice > 0 ? 20 : 90;
      body.sendMail = totalPrice === 0;
    } else {
      body.orderStatus = 90;
      body.sendMail = true;
      body.paymentType = customerPamId;
    }
  }

  function handleApprovedOrder(body, isCreditCard, customerPamId) {
    body.orderStatus = 15;
    body.sendMail = true;
    body.pendingApproval = true;
    if (!isCreditCard) {
      body.paymentType = customerPamId;
    }
  }

  function logOrderSummary(body) {
    dataLayer(
      'kart_siparis_özeti',
      body?.cardType === 0 ? 'Fiziksel Kart' : 'Dijital Kart',
      cardOrderPopupDigital ? 'Pop up - Dijital Kart Seçin' : '',
    );
  }
  return (
    <div className="card-order-summary-content">
      <OrderSummaryInformation />

      <CardDetailInformation />

      <div className="step-btn-container-summary">
        <Button
          id="cardOrders-orderSummary-main-back-btn"
          className="back-btn"
          onClick={() => dispatch(prevStep())}
        >
          <CustomImage src={iconBack} />
          <Text t="turnBack" />
        </Button>
        <Button
          id="cardOrders-orderSummary-main-next-btn"
          className="next-btn"
          style={{ width: 180 }}
          onClick={clickOrderApproval}
        >
          <Text t="approveOrder" />
        </Button>
      </div>
    </div>
  );
};

export default OrderSummary;
